import { render, staticRenderFns } from "./SoPageHead.vue?vue&type=template&id=bff9232a"
import script from "./SoPageHead.vue?vue&type=script&lang=js"
export * from "./SoPageHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports